<script lang="ts" setup>
const selectedCategories = defineModel<string[]>();

const { categories } = defineProps<{
  categories: Array<{ name: string, icon: string, id: string }>;
}>();

const handleClick = (category: { name: string, id: string }) => {
  if (selectedCategories?.value?.includes(category.id)) {
    selectedCategories.value = selectedCategories.value.filter(id => id !== category.id);
  } else {
    selectedCategories?.value?.push(category.id);
  }
};
</script>

<template>
  <div class="category-list">
    <a
      @click="handleClick(category)"
      v-for="category in categories"
      :key="category.id"
      :class="['map-category', selectedCategories.includes(category.id) ? 'selected' : '']"
    >
      <i :class="`${category.icon}`" />
      {{ category.name }}
    </a>
  </div>
</template>

<style scoped>
.category-list {
  user-select: none;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  overflow: hidden;
  max-width: fit-container;
  padding: 0;
  max-width: 90vw;
  overflow-x: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
  }
  a {
    cursor: pointer;
    color: var(--color-slate-700);
    white-space: nowrap;
    padding: 0.25rem 0.25rem;
    transition: padding 0.25s ease-in-out;
    i {
      color: var(--color-slate-400);
      font-size: 1.2rem;
      padding-right: 0.1rem;
    }
  }
  a.selected {
    color: var(--color-slate-900);
    background-color: var(--color-slate-100);
    border-radius: 1rem;
    padding: 0.25rem 0.5rem;
    transition: padding 0.25s ease-in-out;
  }
}
</style>
